import { render, staticRenderFns } from "./AlocationData.vue?vue&type=template&id=2f312aa0&scoped=true&"
import script from "./AlocationData.vue?vue&type=script&lang=ts&"
export * from "./AlocationData.vue?vue&type=script&lang=ts&"
import style0 from "./AlocationData.vue?vue&type=style&index=0&id=2f312aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f312aa0",
  null
  
)

export default component.exports